import { Vehicle } from '@features/vehicles/domain/vehicle.model';
import { createReducer, on } from '@ngrx/store';
import { VehicleStatus } from '@shared/models/enums/vehicle-status.enum';
import { loadVehicle } from '@store/actions/vehicle.actions';

export const initialState: Vehicle = {
    id: 12345,
    historyRegistration: [
        {
            date: '2023-01-15T10:00:00Z',
            status: VehicleStatus.REGISTERED,
        },
        {
            date: '2023-01-14T09:00:00Z',
            status: VehicleStatus.REGISTERING,
        },
    ],
    licensePlateNumber: 'ABC1234',
    licensePlateState: 'CA',
    licensePlateStateName: 'California',
    nickname: 'My Audi',
    rentalRequestedEndDate: '2024-12-31T23:59:59Z',
    numberOfStates: 2,
    createdAt: '2023-01-15T10:00:00Z',
    rentalPeriod: {
        activationDate: '2023-01-15T10:00:00Z',
    },
    states: [
        {
            state: {
                activationType: 'AUTO',
                code: 'CA',
                deactivationType: 'AUTO',
                name: 'California',
                numberOfRoads: 10,
            },
            activationDate: '2023-01-15T10:00:00Z',
            deactivationDate: null,
            mapStatus: 'Active',
            status: VehicleStatus.REGISTERED,
            statusReason: null,
            rental: null,
        },
        {
            state: {
                activationType: 'MANUAL',
                code: 'OR',
                deactivationType: 'MANUAL',
                name: 'Oregon',
                numberOfRoads: 5,
            },
            activationDate: '2023-02-01T11:00:00Z',
            deactivationDate: null,
            mapStatus: 'Pending',
            status: VehicleStatus.PENDING,
            statusReason: 'Awaiting activation',
            rental: {
                requestedEndDate: '2024-12-31T23:59:59Z',
            },
        },
    ],
    status: VehicleStatus.REGISTERED,
    vehicleType: 'CAR',
    stateStatus: {
        pending: 1,
        activating: 0,
        activated: 1,
        notRegistered: 0,
        deactivating: 0,
        deactivated: 0,
        deactivatedBlocked: 0,
        notUnregistered: 0,
        notUpdated: 0,
    },
};

export const vehicleReducer = createReducer(
    initialState,
    on(loadVehicle, (state, action) => {
        return {
            ...state,
            ...action.vehicle,
        };
    })
);
